module.exports = __webpack_public_path__ + "img/120.a4e9e4db.jpg";